import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import RegisterSelect from './pages/RegisterSelect';
import RegisterPrivate from './pages/RegisterPrivate';
import RegisterOrg from './pages/RegisterOrg';
import RegisterCode from './pages/RegisterCode';
import RegisterMenteeCode from './pages/RegisterMenteeCode';
import CompanionInstructions from './pages/CompanionInstructions';
import PortalLogin from './pages/PortalLogin';
import Introduction from './pages/Introduction';
import ProSetup from './pages/ProSetup';
import OrgMenteeSetup from './pages/OrgMenteeSetup';
import IssuedAccessActivation from './pages/IssuedAccessActivation';
import Workspace from './pages/Workspace';
import PrivateMenteeLounge from './pages/PrivateMenteeLounge';
import CorporateMenteeLounge from './pages/CorporateMenteeLounge';
import OrgAdmin from './pages/OrgAdmin';
import SystemAdmin from './pages/SystemAdmin';
import MentorConsole from './pages/MentorConsole';
import StressTestSandbox from './pages/StressTestSandbox';
import SetupHelpDock from './components/SetupHelpDock';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/register-select" element={<RegisterSelect />} />
          <Route path="/register-private" element={<RegisterPrivate />} />
          <Route path="/register-org" element={<RegisterOrg />} />
          <Route path="/register-code" element={<RegisterCode />} />
          <Route path="/register-mentee-code" element={<RegisterMenteeCode />} />
          <Route path="/companion-instructions" element={<CompanionInstructions />} />
          <Route path="/portal-login" element={<PortalLogin />} />
          <Route path="/introduction" element={<Introduction />} />
          <Route path="/pro-setup" element={<ProSetup />} />
          <Route path="/elt-setup" element={<OrgMenteeSetup />} />
          <Route path="/issued-access" element={<IssuedAccessActivation />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/mentee-lounge" element={<PrivateMenteeLounge />} />
          <Route path="/corporate-lounge" element={<CorporateMenteeLounge />} />
          <Route path="/org-admin" element={<OrgAdmin />} />
          <Route path="/system-admin" element={<OrgAdmin />} />
          <Route path="/master-admin" element={<SystemAdmin />} />
          <Route path="/mentor-console" element={<MentorConsole />} />
          <Route path="/stress-test" element={<StressTestSandbox />} />
          <Route path="/guest-briefing" element={<StressTestSandbox />} />
        </Routes>
        <SetupHelpDock />
      </BrowserRouter>
    </AuthProvider>
  );
}
